/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */

import classNames from 'classnames'
import React, { useState } from 'react'
import { useDropzone } from 'react-dropzone'

const MAX_FILE_SIZE = 5000000 // 5 Mb
const MAX_IMAGE_DIMENSION = 1024 // Resize the image for downscaling

const PDF_DATA_URI =
  'data:image/png;base64,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'

const isDataUriImage = dataUri => {
  if (typeof dataUri !== 'string') {
    return false
  }
  const m = dataUri.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/)
  return m && m.length ? m[1].match('image/*') : false
}

const processImage = (imageDataUrl, isImage, done) => {
  if (isImage && MAX_IMAGE_DIMENSION > 0) {
    const img = document.createElement('img')
    img.src = imageDataUrl
    img.onload = () => {
      let width = img.width
      let height = img.height

      if (width > height) {
        if (width > MAX_IMAGE_DIMENSION) {
          height *= MAX_IMAGE_DIMENSION / width
          width = MAX_IMAGE_DIMENSION
        }
      } else {
        if (height > MAX_IMAGE_DIMENSION) {
          width *= MAX_IMAGE_DIMENSION / height
          height = MAX_IMAGE_DIMENSION
        }
      }
      if (width !== img.width || height !== img.height) {
        const canvas = document.createElement('canvas')
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height)
          done(ctx.canvas.toDataURL('image/jpeg', 0.95))
        } else {
          done(null)
        }
      } else {
        done(imageDataUrl)
      }
    }
  } else {
    done(imageDataUrl)
  }
}

const ImageDrop = ({ uid, id, value, label, errors, onChange }) => {
  const [files, setFiles] = useState([])
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*, application/pdf',
    maxSize: MAX_FILE_SIZE,
    multiple: false,
    onDrop: acceptedFiles => {
      if (acceptedFiles.length > 0) {
        const reader = new window.FileReader()
        reader.onload = () =>
          processImage(
            reader.result,
            acceptedFiles[0].type.match('image.*'),
            data => {
              if (data) {
                onChange(data)
              }
            }
          )
        reader.readAsDataURL(acceptedFiles[0])
      }
      setFiles(acceptedFiles)
    }
  })

  if (value) {
    return (
      <img
        id={id}
        src={isDataUriImage(value) ? value : PDF_DATA_URI}
        alt={label}
      />
    )
  }

  return (
    <div className='image-container'>
      <div
        {...getRootProps({
          className: classNames({ imagedrop: true, needsclick: true })
        })}
      >
        <div className='label'>{label}</div>
        {files.length > 0 && (
          <div className='file-info'>
            <div className='image-filetype' data-filetype={files[0].type} />
            <div className='image-filename'>{files[0].name}</div>
          </div>
        )}
        <input {...getInputProps()} />
      </div>
    </div>
  )
}

export default ImageDrop
